export const isStringEmptyOrWhitespaceOnly = (str) => /^\s*$/.test(str)